import React from "react";
import { Route, Routes } from "react-router-dom";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/style.scss";
import "../src/assets/style/width.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./components/Layouts/Layout";
import Login from "./screens/Login/Login";
import Registration from "./screens/Login/Registration";
import Role from "./screens/Role/Role";
import AddRole from "./screens/Role/AddRole";
import UsersList from "./screens/UserList/UsersList";
import DeviceList from "./screens/DeviceList/DeviceList";
import DeviceAdd from "./screens/DeviceList/DeviceAdd";
import LocationMarks from "./screens/Locations/LocationMarks";
import Fixation from "./screens/Login/Fixation";
import AdminAdd from "./screens/AdminList/AdminAdd";
import AdminList from "./screens/AdminList/AdminList";
import UsersView from "./screens/UserList/UserView";
import OwnersList from "./screens/Owners/OwnersList";
import OwnersAdd from "./screens/Owners/OwnersAdd";
import OwnersView from "./screens/Owners/OwnersView";
import ReceptionList from "./screens/Reception/ReceptionList";
import ReceptionView from "./screens/Reception/ReceptionView";
import Banners from "./screens/Masters/Banners";
import RoomCategory from "./screens/Masters/RoomCategory";
import Amenities from "./screens/Masters/Amenities";
import ReceptionAdd from "./screens/Reception/ReceptionAdd";
import Completed from "./screens/Bookings/Completed";
import Cancelled from "./screens/Bookings/Cancelled";
import UpComing from "./screens/Bookings/UpComing";
import UpcomingList from "./screens/Bookings/UpcomingList";
import UpcomingView from "./screens/Bookings/UpcomingView";
import CompletedList from "./screens/Bookings/CompletedList";
import CompletedView from "./screens/Bookings/CompletedView";
import CancelledList from "./screens/Bookings/CancelledList";
import CancelledView from "./screens/Bookings/CancelledView";
import AddBanners from "./screens/Masters/AddBanners";
import ExampleApp from "./Example";
import Notification from "./screens/Notification/Notification";
import Property from "./screens/Property/Property";
import UserReviews from "./screens/Reviews/UserReviews";
import Reviews from "./screens/Reviews/Reviews";
import OwnerReviews from "./screens/Reviews/OwnerReviews";
import ReceptionReviews from "./screens/Reviews/ReceptionReviews";
import PropertyContent from "./screens/Masters/PropertyContent";
import ViewPropertyContent from "./screens/Masters/ViewPropertyContent";
import MinimumAge from "./screens/Masters/MinimumAge";
import TransactionList from "./screens/MMC/TransactionList";
import Suspended from "./screens/MMC/Suspended";
import Approved from "./screens/MMCCancellation.jsx/Approved";
import Request from "./screens/MMCCancellation.jsx/Request";
import Rejected from "./screens/MMCCancellation.jsx/Rejected";
import RoomUnBlock from "./screens/Block/RoomUnBlock";
import PropertyUnBlock from "./screens/Block/PropertyUnBlock";
import SuspendedProperty from "./screens/SuspendedProperty/SuspendedProperty";
import Locations from "./screens/Locations/Locations";
import PropertyView from "./screens/Property/PropertyView";
import PropertyAdd from "./screens/Property/PropertyAdd";
import PropertyRoomAdd from "./screens/Property/PropertyRoomAdd";
import PrivateRoutes from "./screens/redux/store/privateRoutes";
import PropertyRequest from "./components/PropertyVerification/PropertyRequest";
import PropertyApproved from "./components/PropertyVerification/PropertyApproved";
import PropertRejected from "./components/PropertyVerification/PropertRejected";
import DefaultBanner from "./screens/Masters/DefaultBanner";
import PropertyReverification from "./components/PropertyVerification/PropertyReverification";
import PropertyReverificationView from "./components/PropertyVerification/PropertyReverificationView";
import RequestPropertyView from "./screens/PropertyVerification.jsx/RequestPropertyView";
import ApprovePropertyView from "./screens/PropertyVerification.jsx/ApprovePropertyView";
import RejectedPropertyView from "./screens/PropertyVerification.jsx/RejectedPropertyView";
import OLAMap from "./screens/MapTest/OLAMap";
import GMap from "./screens/MapTest/GMap";
import Dashboard from "./screens/Dashboard/Dashboard";
import Sales from "./screens/Sales/Sales";
import Welcome from "./screens/Welcome/Welcome";
import SalesView from "./screens/Sales/SalesView";
import SuspendedPropertyView from "./screens/SuspendedProperty/SuspendedPropertyView";
import MMCReqView from "./screens/MMCCancellation.jsx/MMCReqView";
import MMCApprovView from "./screens/MMCCancellation.jsx/MMCApprovView";
import SuspendedView from "./screens/MMC/SuspendedView";
import AdminSuspended from "./screens/SuspendedProperty/AdminSuspended";
import AdminSuspendedView from "./screens/SuspendedProperty/AdminSuspendedView";
import ChatList from "./screens/ChatList/ChatList";

const ReactRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/map" element={<OLAMap />} />
      <Route path="/gmap" element={<GMap />} />
      {/* <Route path="/registration" element={<Registration />} /> */}
      <Route element={<PrivateRoutes />}>
        <Route element={<Layout />}>
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin-list" element={<AdminList />} />
          <Route path="/admin-add" element={<AdminAdd />} />
          <Route path="/role" element={<Role />} />
          <Route path="/add-role" element={<AddRole />} />
          <Route path="/user-list" element={<UsersList />} />
          <Route path="/device-list" element={<DeviceList />} />
          <Route path="/device-add" element={<DeviceAdd />} />
          <Route path="/location-marks" element={<LocationMarks />} />
          <Route path="/user-view" element={<UsersView />} />
          <Route path="/owner-list" element={<OwnersList />} />
          <Route path="/owner-add" element={<OwnersAdd />} />
          <Route path="/owner-view" element={<OwnersView />} />
          <Route path="/reception" element={<ReceptionList />} />
          <Route path="/recpetion-view" element={<ReceptionView />} />
          <Route path="/recpetion-add" element={<ReceptionAdd />} />
          <Route path="/amenities" element={<Amenities />} />
          <Route path="/room-category" element={<RoomCategory />} />
          <Route path="/banners" element={<Banners />} />
          <Route path="/default-banner" element={<DefaultBanner />} />
          <Route path="/add-banners" element={<AddBanners />} />
          <Route path="/property-content" element={<PropertyContent />} />
          <Route
            path="/view-property-content"
            element={<ViewPropertyContent />}
          />
          <Route path="/minimum-age" element={<MinimumAge />} />
          <Route path="/upcoming" element={<UpComing />} />
          <Route path="/upcoming-list" element={<UpcomingList />} />
          <Route path="/upcoming-view" element={<UpcomingView />} />
          <Route path="/completed" element={<Completed />} />
          <Route path="/completed-list" element={<CompletedList />} />
          <Route path="/completed-view" element={<CompletedView />} />
          <Route path="/cancelled" element={<Cancelled />} />
          <Route path="/cancelled-list" element={<CancelledList />} />
          <Route path="/cancelled-view" element={<CancelledView />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/property" element={<Property />} />
          <Route path="/property-view" element={<PropertyView />} />
          <Route path="/property-add" element={<PropertyAdd />} />
          <Route path="/property-room-add" element={<PropertyRoomAdd />} />
          <Route path="/request-property" element={<PropertyRequest />} />
          <Route path="/approved-property" element={<PropertyApproved />} />
          <Route path="/rejected-property" element={<PropertRejected />} />
          <Route path="/property-req-view" element={<RequestPropertyView />} />
          <Route
            path="/property-approve-view"
            element={<ApprovePropertyView />}
          />
          <Route path="/property-rej-view" element={<RejectedPropertyView />} />
          <Route
            path="/property-reverification"
            element={<PropertyReverification />}
          />
          <Route
            path="/property-reverification-view"
            element={<PropertyReverificationView />}
          />
          <Route path="/user-review" element={<UserReviews />} />
          <Route path="/owner-review" element={<OwnerReviews />} />
          <Route path="/receptionist-review" element={<ReceptionReviews />} />
          <Route path="/review" element={<Reviews />} />
          <Route path="/room-unblock" element={<RoomUnBlock />} />
          <Route path="/property-unblock" element={<PropertyUnBlock />} />
          <Route path="/transaction-list" element={<TransactionList />} />
          <Route path="/suspended" element={<Suspended />} />
          <Route path="/request" element={<Request />} />
          <Route path="/approved" element={<Approved />} />
          <Route path="/rejected" element={<Rejected />} />
          <Route path="/suspended-property" element={<SuspendedProperty />} />
          <Route path="/suspended-property-view" element={<SuspendedPropertyView />} />
          <Route path="/admin-suspended-property" element={<AdminSuspended />} />
          <Route path="/admin-suspended-view" element={<AdminSuspendedView />} />
          <Route path="/location" element={<Locations />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/sales-view" element={<SalesView />} />
          <Route path="/mmc-req-view" element={<MMCReqView />} />
          <Route path="/mmc-appr-view" element={<MMCApprovView />} />
          <Route path="/suspended-view" element={<SuspendedView />} />
          <Route path="/chat-list" element={<ChatList />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default ReactRoutes;
